import { ChatSession } from "./ChatSession";
import { useTalkJSData } from "../../hooks/useChat";

export type Props = {
  children: React.ReactNode;
};

export function ChatSessionContainer({ children }: Props) {
  const talkjsData = useTalkJSData();

  return <ChatSession talkjsData={talkjsData || null}>{children}</ChatSession>;
}

export default ChatSessionContainer;
